import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { CollectionsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { AllCollectionsSpaceProvider } from './AllCollectionsSpaceProvider';
import { CollectionSpaceProvider } from './CollectionSpaceProvider';

export interface CollectionsSpaceRouterOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
}

export type CollectionsSpaceRouterProps = CollectionsSpaceRouterOwnProps;

export class CollectionsSpaceRouter extends React.Component<CollectionsSpaceRouterProps> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.allCollectionsPath()} render={this.provider('all')} />
        <Route exact path={this.props.urls.myCollectionsPath()} render={this.provider('my')} />
        <Route
            exact path={this.props.urls.collectionPath(':luid')}
            render={(routeProps) => <CollectionSpaceProvider
                routeLocationSearch={routeProps.location.search}
                routeLocationPath={routeProps.location.pathname}
                urls={this.props.urls}
                siteName={this.props.siteName}
                collectionLuid={routeProps.match.params.luid}
            />}
        />
        <Route exact path={this.props.urls.collectionsPath()} render={() => (
          <Redirect to={this.props.urls.allCollectionsPath()} />
        )} />
        <Route render={this.error}/>
      </Switch>
    );
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }

  private provider = (subspaceName: CollectionsSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (routeProps): JSX.Element => {
      return <AllCollectionsSpaceProvider
        routeLocationPath={routeProps.location.pathname}
        routeLocationSearch={routeProps.location.search}
        subspaceName={subspaceName}
        urls={this.props.urls}
      />;
    };
  }
}
